// Bootstrap Types and Interfaces

export interface BootstrapRequest {
  company_id: string;
  subscription_type_id?: string;
  user_id?: string;
  force_rebuild?: boolean;
  cleanup_partial?: boolean;
  resume_from_failure?: boolean;
}

export interface BootstrapProgress {
  subscription_exists: boolean;
  subscription_artifact_exists: boolean;
  subscription_artifact_item_exists: boolean;
  company_model_built: boolean;
  state_machines_initialized: boolean;
  features_synced: boolean;
}

export interface BootstrapBlocker {
  step: string;
  error: string;
  error_type: string;
  can_resume: boolean;
  requires_cleanup: boolean;
  suggested_fix?: string;
}

export interface BootstrapFailedStep {
  step: string;
  error: string;
  error_type: string;
  timestamp: string;
}

export interface BootstrapPartialStep {
  step: string;
  status: 'partial';
  details: Record<string, any>;
}

export interface BootstrapResponse {
  success: boolean;
  completed_steps: string[];
  skipped_steps: string[];
  failed_steps: BootstrapFailedStep[];
  partial_steps: BootstrapPartialStep[];
  current_step: string;
  blocker: BootstrapBlocker | null;
  progress: BootstrapProgress;
  details: {
    subscription_id: string | null;
    subscription_type_id: string | null;
    artifact_id: string | null;
    artifact_item_id: string | null;
    artifacts_created: number;
    missing_features: number;
  };
  resume_info?: {
    can_resume: boolean;
    resume_from_step: string;
    next_attempt_will: string;
  };
}

export interface BootstrapErrorResponse {
  detail: {
    message: string;
    blocker: BootstrapBlocker;
    progress: BootstrapProgress;
    completed_steps: string[];
    failed_steps: BootstrapFailedStep[];
    resume_info: {
      can_resume: boolean;
      resume_from_step: string;
      next_attempt_will: string;
    };
  };
}

export class BootstrapError extends Error {
  public detail: BootstrapErrorResponse['detail'];

  constructor(detail: BootstrapErrorResponse['detail']) {
    super(detail.message);
    this.name = 'BootstrapError';
    this.detail = detail;
  }
}

